@if(isSkogsvardFpv$ | async){
<rask-avtal-kund></rask-avtal-kund>
}
@else{
<rask-leverantorsinformation [readonly]="skickadTillVacs()"
    [writePermission]="canEdit()"
    [leverantorer]="leverantorer"
    (onLeverantorChanged)="leverantorUpdated($event)"
    (onFastighetSelected)="fastighetSelectedForImport($event)"
    (leverantorer$)="tempLeverantorerChanged($event)">
</rask-leverantorsinformation>

<rask-virkeskop-validation-message
    entityType="leverantorer">
</rask-virkeskop-validation-message>
}